module.exports = __webpack_public_path__ + "img/003-devil-1.04213997.png";